module.exports = __webpack_public_path__ + "static/img/yiren_code.270bda6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yiren_code.jpg
// module id = sfd+
// module chunks = 1